// This file is automatically generated. Do not edit manually.

import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle";
import { PartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/partConfiguratorType";
import { ConfiguratorLogContext_ConfigurationResolving_Phase } from "src/api/generated/erp/configurator/logging/configuratorLogContext";
import { ConfiguratorLogToAdminUserSender_SendConfiguratorErrorLogToPartResponsiblePersonResult } from "src/api/generated/erp/configurator/misc/configuratorLogToAdminUserSender";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ConfiguratorLogApi {
	export async function getConfiguratorLogFileByPath(args: {
		logPathBase64: string;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/logs/getConfiguratorLogFileByPath",
			method: "POST",
			data: {
				logPathBase64: args.logPathBase64,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function getConfiguratorSessionLogFileBase64Path(args: {
		sessionId: string;
		configuratorType: PartConfiguratorType;
	}): Promise<string> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/logs/getConfiguratorSessionLogFileBase64Path",
			method: "POST",
			data: {
				sessionId: args.sessionId,
				configuratorType: args.configuratorType,
			},
		});
		return response as string;
	}

	export async function getConfiguratorSessionLogFileBase64PathForError(args: {
		errorContextId: string;
	}): Promise<string> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/logs/getConfiguratorSessionLogFileBase64PathForError",
			method: "POST",
			data: {
				errorContextId: args.errorContextId,
			},
		});
		return response as string;
	}

	export async function getTestConfigurationPhaseResolvingLogBase64Path(args: {
		sessionId: string;
		phase: ConfiguratorLogContext_ConfigurationResolving_Phase;
		configuratorType: PartConfiguratorType;
	}): Promise<string> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/logs/getTestConfigurationPhaseResolvingLogBase64Path",
			method: "POST",
			data: {
				sessionId: args.sessionId,
				phase: args.phase,
				configuratorType: args.configuratorType,
			},
		});
		return response as string;
	}

	export async function sendConfiguratorErrorLogToPartResponsiblePerson(args: {
		errorContextId: string;
	}): Promise<ConfiguratorLogToAdminUserSender_SendConfiguratorErrorLogToPartResponsiblePersonResult> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/logs/sendConfiguratorErrorLogToPartResponsiblePerson",
			method: "POST",
			data: {
				errorContextId: args.errorContextId,
			},
		});
		return response as ConfiguratorLogToAdminUserSender_SendConfiguratorErrorLogToPartResponsiblePersonResult;
	}

	export async function analyzeLogWithAi(args: { logPathBase64: string }): Promise<string> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/logs/analyzeLogWithAi",
			method: "POST",
			data: {
				logPathBase64: args.logPathBase64,
			},
		});
		return response as string;
	}
}
